

export const index = 5;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/admin/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/5.CZLPMpCh.js","_app/immutable/chunks/disclose-version.BfHQzUcx.js","_app/immutable/chunks/index-client.HYok5wSr.js","_app/immutable/chunks/legacy.DG24rG7b.js","_app/immutable/chunks/render.BLNanXqs.js","_app/immutable/chunks/props.DuautN8q.js","_app/immutable/chunks/class.0_EMInml.js","_app/immutable/chunks/lifecycle.C79b4KUY.js","_app/immutable/chunks/entry.C-LI3Ywc.js","_app/immutable/chunks/index.B5_iRLox.js"];
export const stylesheets = ["_app/immutable/assets/5.3wE9sass.css","_app/immutable/assets/fa-layers-text.DdWHEj6G.css"];
export const fonts = [];
